import axios from "axios";
import Cookies from "js-cookie";
import * as types from "../mutation-types";
import { changeLocale } from "../../plugins/i18n.js";
import store from "~/store";
import logger from "~/utilities/logger";

export default {
  namespaced: true,

  // state
  state: {
    user: null,
    token: Cookies.get("pde_token"),
    sugar_access_token: false,
    sugar_connection_promise: null,
  },
  // getters
  getters: {
    user: (state) => state.user,
    token: (state) => state.token,
    check: (state) => state.user !== null,
    checkWelcome: (state) => state.token,
    sugar_access_token: (state) => state.sugar_access_token,
  },

  mutations: {
    [types.SAVE_TOKEN](state, { token, remember })
    {
      state.token = token;
      Cookies.set("pde_token", token, { expires: remember ? 365 : null });
    },
    SET_SUGAR_TOKEN(state, { connected })
    {
      state.sugar_access_token = !!connected;
    },

    CLEAR_SUGAR_TOKEN(state)
    {
      state.sugar_access_token = false;
    },

    SET_CONNECTION_PROMISE(state, promise)
    {
      state.sugar_connection_promise = promise;
    },

    [types.FETCH_USER_SUCCESS](state, { user })
    {
      const level = user?.usr_level || null;

      if (level)
      {
        user.roles = [];

        // TODO - move this to config
        const levels = {
          99: "SUPERADMIN",
          20: "ADMIN",
          10: "HM",
          5: "PLANNER",
          1: "USER",
        };

        if (levels?.[level]) user.roles.push(levels?.[level]);

        if (level <= 5)
        {
          //Planner can also be PMs and TMs
          if (!!user?.projects?.length) user.roles.push("PM");
          if (!!user?.hierarchy?.length) user.roles.push("TM");
        }

        logger.log("user.roles", user.roles);

        // const locale = user.usr_language ? user.usr_language : 'en'; //todo
        // const currLocale = Cookies.get('locale') || 'en';
        // if (currLocale !== locale) {
        //   Cookies.set('locale', locale, { expires: 365 });
        // }
      }
      return (state.user = user);
    },

    [types.FETCH_USER_FAILURE](state)
    {
      console.error("FETCH FAILED");
      // Cookies.remove('pde_token');
      // return state.token = null;
    },

    [types.LOGOUT](state)
    {
      Cookies.remove("pde_token");
      return (state = null);
    },

    [types.UPDATE_USER](state, { user })
    {
      state.user = user;
    },
  },

  // actions
  actions: {
    saveToken({ commit, dispatch }, payload)
    {
      return commit(types.SAVE_TOKEN, payload);
    },
    async sugarConnection({ state, dispatch })
    {
      if (state.sugar_connection_promise)
      {
        return state.sugar_connection_promise;
      }

      logger.log("sugarConnection: ensuring backend Sugar connection");
      return dispatch('fetchSugarToken');
    },

    async fetchSugarToken({ commit })
    {
      const connectionPromise = (async () =>
      {
        try
        {
          const response = await axios.get('/api/sugarcrm/tokens');

          if (response.data.error)
          {
            throw new Error(response.data.error);
          }

          commit('SET_SUGAR_TOKEN', {
            connected: !!response.data.connected,
          });

          return !!response.data.connected;
        } catch (error)
        {
          console.error('SugarCRM auth failed:', error);
          commit('CLEAR_SUGAR_TOKEN');
          throw error;
        } finally
        {
          commit('SET_CONNECTION_PROMISE', null);
        }
      })();

      commit('SET_CONNECTION_PROMISE', connectionPromise);
      return connectionPromise;
    },

    async refreshSugarToken({ commit, dispatch })
    {
      const connectionPromise = (async () =>
      {
        try
        {
          const response = await axios.post('/api/sugarcrm/accesstoken');

          if (response.data.error)
          {
            throw new Error(response.data.error);
          }

          commit('SET_SUGAR_TOKEN', {
            connected: !!response.data.connected,
          });

          return !!response.data.connected;
        } catch (error)
        {
          // no valid refresh token -> Fresh auth
          commit('SET_CONNECTION_PROMISE', null);
          return dispatch('fetchSugarToken');
        } finally
        {
          commit('SET_CONNECTION_PROMISE', null);
        }
      })();

      commit('SET_CONNECTION_PROMISE', connectionPromise);
      return connectionPromise;
    },

    sugarLogout({ commit })
    {
      commit('CLEAR_SUGAR_TOKEN');
    },

    async fetchUser({ commit })
    {
      try
      {
        const { data } = await axios.get("/api/user");
        logger.log("store.fetchUser", data);
        changeLocale(data.data.usr_language);
        return commit(types.FETCH_USER_SUCCESS, { user: data && data?.data });
      } catch (e)
      {
        logger.error("store.fetchUser", e);
        return commit(types.FETCH_USER_FAILURE);
      }
    },

    updateUser({ commit }, payload)
    {
      commit(types.UPDATE_USER, payload);
    },

    async logout({ commit })
    {
      try
      {
        await axios.post("/api/logout");
      } catch (e) {}

      return commit(types.LOGOUT);
    },

    async fetchOauthUrl(ctx, { provider })
    {
      const { data } = await axios.post(`/api/oauth/${provider}`);

      return data && data?.url;
    },

    async checkRoles({ _ }, roles)
    {
      if (!store.getters["auth/user"])
      {
        await store.dispatch("auth/fetchUser");
      }
      const user = store.getters["auth/user"];

      return checkRoles(roles, user);
    },

    async checkSugar({ _ })
    {
      if (!store.getters["auth/user"])
      {
        await store.dispatch("auth/fetchUser");
      }
      const user = store.getters["auth/user"];

      return checkSugar(user);
    },
  },
};

export const checkRoles = (roles, user = null) =>
{
  if (!user)
  {
    user = store.getters["auth/user"];
  }
  const userRoles = user.roles;

  if (!Array.isArray(roles) || !Array.isArray(userRoles)) return;

  if (!roles?.length)
  {
    //  user.roles.includes(roles); - must be array - array
    return userRoles.some((role) => roles.includes(role));
  }

  // Why we need to check both ???
  return roles.some((role) => userRoles.includes(role));
};

export const checkSugar = (user = null) => 
{
  if (!user)
  {
    user = store.getters["auth/user"];
  }
  return user.usr_sugar_access === 1;
}